"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

var _dateFns = require("date-fns");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _blocks = require("@bueno/blocks");

var _time = require("../../../utils/time");

var _getUniqueId = _interopRequireDefault(require("../../../utils/getUniqueId"));

var _ToolTip = _interopRequireDefault(require("../../ToolTip"));

var _ToolTip2 = require("../../ToolTip/ToolTip.styles");

var _RowSnooze = _interopRequireDefault(require("./RowSnooze"));

var _RowAction = _interopRequireDefault(require("./RowAction"));

var _eventTracking = require("../../../utils/eventTracking");

var _Equip = require("./Equip.styles");

var _ViewAction = require("../../ActionModals/ViewAction/components/ViewAction");

var _toFixed = require("../../../utils/toFixed");

var _aperture = require("../../../utils/aperture");

var _utils = require("../../HistoryModal/context/utils");

var _tenant = require("../../../utils/tenant");

const StyledCell = (0, _styledComponents.default)(_blocks.DataGridCell)`
  height: unset;
  min-height: 56px;
  max-height: calc(16px * 12);
  flex-grow: 1;
`;
const EquipCell = (0, _styledComponents.default)(StyledCell)`
  overflow: visible;
`;
const DescriptionCell = (0, _styledComponents.default)(StyledCell)`
  // set max number of lines based on line-height
  overflow-x: hidden;
  overflow-y: auto;
  align-items: flex-start;

  ${_blocks.Main} {
    white-space: normal;
    padding: 8px 0;
  }
`;

function formatPrettyTimes(seconds) {
  if (seconds === 86400) return '24hr';
  const dur = (0, _dateFns.intervalToDuration)({
    start: new Date(),
    end: (0, _dateFns.sub)(new Date(), {
      seconds
    })
  });
  const total = {
    hours: dur.hours,
    minutes: dur.minutes
  };
  return `${total.hours}hr ${total.minutes}mins`;
}

function formatPrettyHours(hours) {
  // If full day, return early with known values
  // NOTE: moment will treat 24 hours as { hours: 0, days: 1 }
  if (Number(hours) === 24) return {
    hours: 24,
    minutes: 0
  }; // Otherwise break out into hours and minutes
  // const m = moment.duration({ hours })

  const dur = (0, _dateFns.intervalToDuration)({
    start: new Date(),
    end: (0, _dateFns.sub)(new Date(), {
      minutes: hours * 60
    })
  });
  return {
    hours: dur.hours,
    minutes: dur.minutes
  };
}

const triggerReportViewedEvent = asset => () => {
  (0, _eventTracking.clickedTrendGraphEvent)(asset);
};

const EquipRow = /*#__PURE__*/React.memo(({
  asset,
  onSelect,
  isSelected,
  handleLastClickedModal,
  lastClickedModal,
  showCreateAction
}) => {
  const historyViewerUrl = (0, _tenant.useApertureUrl)();
  const [isActive, setIsActive] = React.useState(false);
  const handleMenuToggle = React.useCallback(active => {
    if (lastClickedModal !== asset.occurrenceId) {
      setIsActive(active);
    }
  }, [lastClickedModal]);
  React.useEffect(() => {
    setIsActive(lastClickedModal === asset.occurrenceId);
  }, [lastClickedModal]);
  const {
    occurrenceId,
    duration,
    targetName: equipName,
    averageDur,
    equipRuleId,
    description,
    times,
    issueKey,
    ruleType,
    isSnoozed,
    snoozeEnd,
    occurredOn
  } = asset;
  const total = formatPrettyHours(duration);
  const average = formatPrettyHours(averageDur);
  const {
    start: rangeStart,
    end: rangeEnd
  } = (0, _utils.getHistoryDateRange)(asset.occurredOn);
  return /*#__PURE__*/React.createElement(_Equip.EquipListRow, {
    isActive: isActive,
    isSnoozed: isSnoozed,
    "data-cy": "EquipRow",
    cursor: "pointer"
  }, /*#__PURE__*/React.createElement(EquipCell, null, issueKey == null ? /*#__PURE__*/React.createElement(_blocks.Checkbox, {
    checked: isSelected,
    onChange: onSelect,
    small: true
  }) : ''), /*#__PURE__*/React.createElement(EquipCell, null, /*#__PURE__*/React.createElement(_blocks.Main, null, (0, _time.todayYesterday)(occurredOn))), /*#__PURE__*/React.createElement(EquipCell, {
    maxWidth: "200px"
  }, /*#__PURE__*/React.createElement(_blocks.Main, {
    title: equipName
  }, equipName)), /*#__PURE__*/React.createElement(EquipCell, null, /*#__PURE__*/React.createElement(_ToolTip.default, null, ({
    isOpen,
    open,
    close
  }) => /*#__PURE__*/React.createElement("div", {
    style: {
      position: 'relative'
    },
    onMouseEnter: open,
    onMouseLeave: close
  }, /*#__PURE__*/React.createElement(_blocks.Main, null, times.length, " Hit", times.length > 1 ? 's' : ''), /*#__PURE__*/React.createElement(_blocks.Supportive, null, "Avg. ", (0, _toFixed.toFixed)(averageDur, 2), " hrs"), /*#__PURE__*/React.createElement(_ToolTip2.ToolTip, {
    isOpen: isOpen
  }, /*#__PURE__*/React.createElement(_ToolTip2.Tip, null, /*#__PURE__*/React.createElement(_ToolTip2.TipTitle, null, /*#__PURE__*/React.createElement("div", null, "Hits Duration (24hr period)")), /*#__PURE__*/React.createElement(_ToolTip2.TipRow, null, /*#__PURE__*/React.createElement("div", null, "Total:", ' ', /*#__PURE__*/React.createElement("strong", null, total.hours, "hr ", total.minutes, "mins")), /*#__PURE__*/React.createElement("div", null, "Average:", ' ', /*#__PURE__*/React.createElement("strong", null, average.hours, "hr ", average.minutes, "mins"))), /*#__PURE__*/React.createElement(_ToolTip2.TipRow, null, /*#__PURE__*/React.createElement("div", null, times.map(time => /*#__PURE__*/React.createElement("div", {
    key: (0, _getUniqueId.default)()
  }, time.t, " ", formatPrettyTimes(time.d)))))))))), /*#__PURE__*/React.createElement(DescriptionCell, null, /*#__PURE__*/React.createElement(_blocks.Main, {
    title: description
  }, description)), /*#__PURE__*/React.createElement(EquipCell, null, /*#__PURE__*/React.createElement(_blocks.Main, null, /*#__PURE__*/React.createElement("span", null, ruleType))), /*#__PURE__*/React.createElement(EquipCell, {
    minWidth: "120px"
  }, /*#__PURE__*/React.createElement(React.Fragment, null, issueKey ? /*#__PURE__*/React.createElement(_ViewAction.ViewAction, {
    actionId: issueKey,
    onOpen: () => {
      handleLastClickedModal(occurrenceId);
    }
  }) : /*#__PURE__*/React.createElement("span", null))), /*#__PURE__*/React.createElement(EquipCell, {
    minWidth: "140px"
  }, /*#__PURE__*/React.createElement("div", {
    className: "Row-actions-snoozeIcon"
  }, /*#__PURE__*/React.createElement(_RowSnooze.default, {
    className: undefined,
    isSnoozed: isSnoozed,
    snoozeEnd: snoozeEnd,
    onMenuToggle: setIsActive,
    equipRuleId: equipRuleId
  })), /*#__PURE__*/React.createElement("div", {
    className: "Row-actions-reportIcon"
  }, /*#__PURE__*/React.createElement(_Equip.Icon, null, /*#__PURE__*/React.createElement("a", {
    href: (0, _aperture.getApertureHistoryLink)({
      baseUrl: historyViewerUrl,
      organisationId: asset.site.projectId,
      ruleId: asset.ruleId,
      siteId: asset.site.forgeId,
      equipId: asset.forgeId,
      occurrenceId: asset.occurrenceId,
      range: [rangeStart, rangeEnd]
    }),
    onClick: triggerReportViewedEvent(asset),
    target: "_blank",
    rel: "noopener"
  }, /*#__PURE__*/React.createElement(_blocks.AnalyticsTrends, null)))), /*#__PURE__*/React.createElement("div", {
    className: "Row-actions-actionIcon"
  }, /*#__PURE__*/React.createElement(_RowAction.default, {
    actionId: issueKey,
    equipRuleId: equipRuleId,
    occurrenceId: occurrenceId,
    onMenuToggle: handleMenuToggle,
    showCreateAction: showCreateAction,
    isAssociated: issueKey != null,
    handleLastClickedModal: handleLastClickedModal
  }))));
}, (p, c) => p.asset === c.asset && p.isSelected === c.isSelected && p.lastClickedModal === c.lastClickedModal);
var _default = EquipRow;
exports.default = _default;
module.exports = exports.default;